import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WindowStateService {

  private isWindowActive = new BehaviorSubject<boolean>(true);
  isWindowActive$ = this.isWindowActive.asObservable();

  constructor(private ngZone: NgZone) {
    this.listenToVisibilityChange();
  }

  private listenToVisibilityChange() {
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('visibilitychange', () => {
        this.ngZone.run(() => {
          this.isWindowActive.next(document.visibilityState === 'visible');
        });
      });

      window.addEventListener('focus', () => {
        this.ngZone.run(() => this.isWindowActive.next(true));
      });

      window.addEventListener('blur', () => {
        this.ngZone.run(() => this.isWindowActive.next(false));
      });
    });
  }
}
